// extracted by mini-css-extract-plugin
module.exports = {"root":"DHezU","collapsed":"_13NYZ"};